import Vuex from 'vuex'
import { auth } from './modules/auth'
import domains from './modules/domains'
import dns from './modules/dns'
import mail from './modules/mail'
import apikeys from './modules/apikeys'
import users from './modules/users'

// Create store
const store = Vuex.createStore({
  modules: {
    auth,
    domains,
    dns,
    mail,
    apikeys,
    users
  },
  //plugins: []
})


export default store;